import { List, Map } from 'immutable';
import { gemSeed } from '../Card/gemLayout';

/** What a Pokémon in play is for working out moves: the card, and how many energy cards are on it. */
const pokemon = (row, card) => (row ? {
  rowId: row.get('pivot_id') || row.get('id'),
  cardId: card ? card.get('id') : null,
  card,
  energy: (row.get('energyAttachments') || List()).map(attachment => attachment.get('card')),
  damage: row.get('damage') || 0,
  /** Where its damage counters sit (gemSeed): a knocked-out one flies to the discard pile with them as they were. */
  seed: gemSeed(row, card),
} : null);

/**
 * One player's side, reduced to what can move: their active Pokémon, bench, hand, deck, discard pile and prizes.
 *
 * @param {Map|undefined} player from selectPlayer or selectOpponent
 */
export function snapshot(player) {
  if (!player || !player.get('user')) {
    return null;
  }

  const active = player.get('activePokemon');
  const bench = player.getIn(['bench', 'cards']) || List();
  const hand = player.get('hand');
  const discard = player.getIn(['discardPile', 'cards']) || List();

  return {
    userId: player.getIn(['user', 'id']),
    active: active && !active.get('face_down') ? pokemon(active, active.get('card')) : null,
    /** A face-down Pokémon (the opponent's during setup) turning up isn't a move. */
    activeFaceDown: !!(active && active.get('face_down')),
    bench: Map(bench.map(card => [card.get('order'), pokemon(card, card.get('id') ? card : null)])),
    handCount: hand ? hand.get('count') : 0,
    handCards: hand ? (hand.get('cards') || List()).map(card => ({ pivotId: card.get('pivot_id'), card })) : List(),
    deckCount: player.getIn(['deckPile', 'count']) || 0,
    discardCount: discard.size,
    discardTop: discard.sortBy(card => card.get('order')).last() || null,
    prizes: (player.getIn(['prizePile', 'cards']) || List()).map(card => card.get('order')).toSet(),
  };
}
